module.exports = __webpack_public_path__ + "img/渠村乡.703f6ba6.png";